// extracted by mini-css-extract-plugin
export var container = "_48-0";
export var icon = "_48-1";
export var text = "_48-2";